/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export * from "./IIntegration";
export * from "./IIntegrationManager";
export * from "./IIntegrationDefinition";
export * from "./IIntegrationFactory";
export * from "./IIntegrationFactory";
export * from "./IIntegrationOptions";
export * from "./ISshTunnelService";
export * from "./IS3StorageOptions";

export * from "./fixIntegrationParams";
export * from "./FunctionResultDecorator";
export * from "./FunctionDecorator";
export * from "./StoreDefinition";
export * from "./IntegrationBase";
export * from "./createIntegrationFactory";
export * from "./createIntegrationDefinition";
export * from "./MethodDecorator";
